import clsx from 'clsx'
import numeral from 'numeral'
import {useRegionConfig} from '../../../../../hooks'

interface AdPriceProps {
    price: number
    // Старая цена: показывается, только если была скидка.
    previousPrice?: number | null
}

// Цена объявления в списке и старая цена, если была скидка.
export function AdPrice(props: AdPriceProps) {

    const regionConfig = useRegionConfig()
    const currency: string = regionConfig.numeral.localeConfig.currency.symbol
    const numeralFormat: string = regionConfig.moneyInput.numeralFormat

    const {
        price,
        previousPrice,
    } = props

    return (
        <div className="offered-item-card-price d-flex flex-column align-items-start">
            <div
                className={clsx(
                    'current-price',
                    'd-flex flex-row align-items-center gap-1 lh-1'
                )}
            >
                <span className="price-amount fs-4 fw-700">
                    {numeral(price).format(numeralFormat)}
                </span>
                <span className="price-currency fs-5 fw-500">
                    {currency}
                </span>
            </div>
            {previousPrice && (
                <div className="previous-price d-flex flex-row align-items-center gap-1 text-light-gray fw-500">
                    <s className="price-amount fs-5">
                        {numeral(previousPrice).format(numeralFormat)}
                    </s>
                    <span className="price-currency">
                        {currency}
                    </span>
                </div>
            )}
        </div>
    )
}
